// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-2e7765b8] .el-select__tags-text{display:inline-block;max-width:60px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}@media(max-width:1400px){[data-v-2e7765b8] .el-select__tags-text{max-width:42px}}[data-v-2e7765b8] .el-select .el-tag__close.el-icon-close{top:-7px;right:-4px}", ""]);
// Exports
module.exports = exports;
